import React from 'react';
import PropTypes from 'prop-types';
import { PlusIcon, MinusIcon } from '@glu/icons-react';
import { useSelector } from 'react-redux';
import { withStyles } from 'theme/withStyles';

const styles = (theme) => ({
  icon: {
    '& svg': {
      fill: theme.palette.icon,
    },
    pointerEvents: 'none',
  },
});

const PlusMinus = ({ classes, collapsed }) => {
  const hasTheme = useSelector((state) => state.ui.hasTheme);
  if (!hasTheme) {
    return <i className="icon-plus-minus" aria-hidden="true" />;
  }
  if (collapsed) {
    return <PlusIcon className={classes.icon} aria-hidden="true" />;
  }
  return <MinusIcon className={classes.icon} aria-hidden="true" />;
};

PlusMinus.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  collapsed: PropTypes.bool,
};

PlusMinus.defaultProps = {
  collapsed: false,
};

export default withStyles(styles)(PlusMinus);
